import { render } from "./ContactoComp.vue?vue&type=template&id=34001eba&scoped=true"
import script from "./ContactoComp.vue?vue&type=script&lang=js"
export * from "./ContactoComp.vue?vue&type=script&lang=js"

import "./ContactoComp.vue?vue&type=style&index=0&id=34001eba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34001eba"]])

export default __exports__